module.exports = __webpack_public_path__ + "static/cover-2-df9ab40bf59a766bd23503569a778af8.png";